import { useEffect, useState } from "react";
import axiosConfig from "../axiosConfig";
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";

const ChannelDisable = () => {
    const [channels, setChannels] = useState([]);
    const [query, setQuery] = useState("");

    useEffect(() => {
        axiosConfig.get("/channel/subscription/channel-list-all").then((rsp) => {
            const list = Array.isArray(rsp.data) ? rsp.data : (rsp.data.channels || []);
            setChannels(list);
        }).catch(() => {
        });
    }, []);

    const isDisabled = (channel) => {
        return String(channel.active) === "0";
    };

    const handleToggle = (channel) => {
        const willDisable = !isDisabled(channel);
        const confirmMessage = willDisable
            ? "Disable this channel? It will stop viewlogs and hide from dashboard."
            : "Enable this channel? It will resume viewlogs and show on dashboard.";

        if (!window.confirm(confirmMessage)) {
            return;
        }

        const nextActive = !willDisable;
        const payload = { channel_id: channel.id, active: nextActive };

        axiosConfig.post("/channel/subscription/activate-deactivate", payload).then(() => {
            setChannels((prev) => prev.map((item) => {
                if (item.id === channel.id) {
                    return { ...item, active: nextActive ? 1 : 0 };
                }
                return item;
            }));
        }).catch(() => {
            alert("Unable to update channel. Please try again.");
        });
    };

    const filteredChannels = channels.filter((channel) => {
        const name = channel.channel_name || channel.name || "";
        return name.toLowerCase().includes(query.toLowerCase());
    });

    return (
        <div><Header title="Channel Disable" />
            <MainMenu menu="channel-subscriptions" />
            <div class="content">
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >

                    <div class="content-body">
                        <div class="row justify-content-md-center">
                            <div class="col-12">
                                <div class="card">

                                    <div class="card-content collapse show">
                                        <div class="card-body card-dashboard">

                                            <div class="row">
                                                <div class="col-md-7"><div class="h3 font-weight-bold">Channel Disable</div></div>
                                                <div class="col-md-5">
                                                    <input
                                                        type="text"
                                                        class="search form-control round border-primary mb-1"
                                                        placeholder="Search by Channel Name"
                                                        onChange={e => setQuery(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <br />

                                            <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                <table class="table display nowrap table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Channel</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredChannels.map((channel) => (
                                                            <tr key={channel.id}>
                                                                <td>
                                                                    {channel.logo ? (
                                                                        <img
                                                                            class="img-fluid"
                                                                            alt=""
                                                                            style={{ maxWidth: "3rem" }}
                                                                            src={"../../channels/logos/" + channel.logo}
                                                                        />
                                                                    ) : null}
                                                                    {channel.channel_name || channel.name}
                                                                </td>
                                                                <td>
                                                                    {isDisabled(channel) ? (
                                                                        <span class="badge badge-danger">Disabled</span>
                                                                    ) : (
                                                                        <span class="badge badge-success">Enabled</span>
                                                                    )}
                                                                </td>
                                                                <td style={{ whiteSpace: "nowrap" }}>
                                                                    <button
                                                                        class={isDisabled(channel) ? "btn btn-sm btn-success" : "btn btn-sm btn-danger"}
                                                                        onClick={() => handleToggle(channel)}
                                                                    >
                                                                        {isDisabled(channel) ? "Enable" : "Disable"}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    );
};

export default ChannelDisable;
